export enum SideFrameDataEventObject {
  CONVERSATION_QA_REVIEW = 'conversation_qa_review',
  CONVERSATION_QA_REVIEW_FEEDBACK = 'conversation_qa_review_feedback',
  CONVERSATION_QA_REVIEW_EDIT = 'conversation_qa_review_edit',
  CONVERSATION_QA_REVIEW_APPROVAL = 'conversation_qa_review_approval',
  CONVERSATION_QA_CITATION_EXPAND = 'conversation_qa_citation_expand',
  CONVERSATION_QA_CITATION_SOURCE = 'conversation_qa_citation_source',
  CONVERSATION_CSAT_CITATION_EXPAND = 'conversation_csat_citation_expand',
  CONVERSATION_CSAT_CITATION_SOURCE = 'conversation_csat_citation_source',
  SMART_PRODUCTS_UPSELL = 'smart_products_upsell',
  RELATIONSHIPS_ACCOUNT_DETAILS = 'relationships_account_details',
  RELATIONSHIPS_ACCOUNT_ACTIVITIES_SHOW_MORE = 'relationships_account_activities_show_more',
  RELATIONSHIPS_CONTACT_CONVERSATIONS_SHOW_MORE = 'relationships_contact_conversations_show_more',
  RELATIONSHIPS_ACCOUNT_NAME_LINK = 'relationships_account_name_link',
  RELATIONSHIPS_ACCOUNT_EMPTY_STATE = 'relationships_account_empty_state',
  RELATIONSHIPS_ACCOUNT_CONTACT_ADD = 'relationships_account_contact_add',
  RELATIONSHIPS_ACCOUNT_COPY_LINK = 'relationships_account_copy_link',
  RELATIONSHIPS_ACCOUNT_DELETE = 'relationships_account_delete',
  RELATIONSHIPS_ACCOUNT_SWITCHER = 'relationships_account_switcher',
  RELATIONSHIPS_ACCOUNT_SWITCHER_REMOVE = 'relationships_account_switcher_remove',
  RELATIONSHIPS_PANEL_CONTACTS_TAB = 'relationships_panel_contacts_tab',
  RELATIONSHIPS_PANEL_ACCOUNTS_TAB = 'relationships_panel_accounts_tab',
  RELATIONSHIPS_PANEL_SUMMARIZE_INSIGHTS = 'relationships_panel_summarize_insights',
  ACCOUNT_PLANS_SECTION = 'account_plans_section',
}
